import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import BillsService from "@/api-client/api/services/billsService/billsService";

export function ConfirmCancelPeriod({
  trigger,
  selectedBuildAddress,
  setPeriodMonthYear,
  setSelectedPeriodOptions,
}: {
  trigger: React.ReactNode;
  setPeriodMonthYear: (periodMonthYear: string | undefined) => void;
  selectedBuildAddress: { label: string; value: string };
  setSelectedPeriodOptions: (selectedPeriodOptions: {
    name: string;
    value: string;
  }) => void;
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleDialogClose = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  const cancelPeriod = async () => {
    try {
      await BillsService.postCancelPeriod(Number(selectedBuildAddress.value));
      setIsOpen(false);
      setPeriodMonthYear(undefined);
      setSelectedPeriodOptions({
        name: t("house_manager.closed_periods"),
        value: "closed_periods",
      });
    } catch (error) {
      console.error("Error canceling period:", error);
    }
  };


  return (
    <Dialog open={isOpen} onOpenChange={handleDialogClose} modal={false}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>

      {isOpen && (
        <div className="fixed inset-0 bg-black/10 backdrop-blur-[4px] z-40 pointer-events-none"></div>
      )}
      <DialogContent className="max-h-full overflow-auto w-[440px] pb-[40px]">
        <DialogHeader className="mb-[16px]">
          <DialogTitle className="text-[24px] font-medium flex items-center justify-center gap-4">
              <div className="border-[3px] border-[#FF0000] text-[#FF0000] rounded-full w-[48px] h-[48px] flex items-center justify-center">
                !
              </div>
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-4 mb-4">
          <span className="text-[24px] font-medium text-center">
            {t("popUpCancelPeriod.cancel_period")}
          </span>

          <span className="text-[18px] font-medium text-[#00000080] text-center">
            {t("popUpCancelPeriod.confirm_cancel_period_description")}
          </span>
        </div>

        <Button
          type="submit"
          variant="system"
          size="system"
          disabled={false}
          loading={false}
          onClick={() => {
            cancelPeriod();
          }}
        >
          {t("popUpCancelPeriod.confirm_cancel_period")}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
